import ComponentBase from 'components/_base/ComponentBase';
import HotelDetailPanel from '../hotelDetailPanel/HotelDetailPanel';
import { RESULTS_DESTINATION, DESTINATIONS_TREE } from '../../globals/widgetTypes';
const SUMMARY_PANEL_HEIGHT = 64;

const hotelSummaryMobilePanel = ComponentBase.extend({
	template: require('./hotelSummaryMobilePanel.hbs'),
	componentClass: 'hotel-resume-mobile-panel',
	events: {
		'click .collapse-visible-panel': 'onClickInSeeDetails'
	},

	initialize(options) {
		ComponentBase.prototype.initialize.call(this, options);
		this.isResultsWidget = this.widget.typeWidget === RESULTS_DESTINATION || this.widget.typeWidget === DESTINATIONS_TREE;
		this.hide();
		if (options.properties.hotelData) {
			this.updateDataHotel(options.properties.hotelData);
		}
		google.maps.event.addDomListener(this.widget.map, 'resize', () => {
			this.calculateSizesContainers();
		});
		this.listenTo(this.bus, 'CLICK_ON_MAIN_HOTEL_MARKER', () => {
			this.onClickInSeeDetails();
		});
	},

	updateDataHotel(hotelData) {
		const { title, imgDetail } = hotelData.hotel.hotelSection;

		this.templateConfig = {
			title,
			imgDetail,
			isResultsWidget: this.isResultsWidget
		};

		this.$el.replaceWith(this.render().$el);
		this.createExpansivePanel(hotelData);
		this.$el.find('.uncollapse-visible-panel').append(this.expandedPanel.el);
		this.calculateSizesContainers();
		if (this.isResultsWidget) {
			this.$el.animate({
				top: 0
			});
		}
		this.show();
	},

	onClickInSeeDetails() {
		this.$el.animate({
			top: -SUMMARY_PANEL_HEIGHT
		});
	},

	calculateSizesContainers() {
		const widgetHeight = this.widget.getHeight();
		let heightAllPanel;
		let heightDataPanel;
		let topPositionAllPanel;
		if (this.isResultsWidget) {
			heightAllPanel = widgetHeight;
			heightDataPanel = widgetHeight;
			topPositionAllPanel = widgetHeight;
		} else {
			heightAllPanel = widgetHeight + SUMMARY_PANEL_HEIGHT;
			topPositionAllPanel = widgetHeight - SUMMARY_PANEL_HEIGHT;
		}
		this.$el.find('.uncollapse-visible-panel').css({
			height: heightDataPanel
		});
		this.$el.css({
			height: heightAllPanel,
			top: topPositionAllPanel
		});
	},

	createExpansivePanel(hotelData) {
		this.expandedPanel = new HotelDetailPanel({
			position: 'hotel-detail-panel',
			componentConstructorClass: 'HotelDetailPanel',
			identifier: 'HotelDetailPanel',
			map: this.widget.map,
			widget: this.widget,
			isChild: true,
			parent: this,
			properties: {
				hotelData: hotelData ? hotelData : null
			}
		});
	},

	collapsePanel() {
		let positionCollapsabled;
		if (this.isResultsWidget) {
			positionCollapsabled = this.widget.getHeight();
		} else {
			positionCollapsabled = this.widget.getHeight() - SUMMARY_PANEL_HEIGHT;
		}
		this.$el.animate({
			top: positionCollapsabled
		}, {
			complete: () => {
				this.$el.hide();
			}
		});
	}
});
export default hotelSummaryMobilePanel;



// WEBPACK FOOTER //
// ./src/components/hotelSummaryMobilePanel/hotelSummaryMobilePanel.js